"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Track = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
function shouldDisplaySegment(segmentIndex, mode) {
    if ('odd-segments' === mode && 0 === (segmentIndex + 1) % 2) {
        return true;
    }
    else if ('even-segments' === mode && 0 === segmentIndex % 2) {
        return true;
    }
    return false;
}
function generateSegments(values, min, max) {
    const segments = [];
    const newValues = [...values];
    newValues.sort((a, b) => a - b);
    if (0 === newValues.length ||
        newValues[0] < min ||
        newValues[newValues.length - 1] > max ||
        min === max) {
        return [];
    }
    let lastValue = min;
    for (let i = 0; i < newValues.length; i++) {
        segments.push({ left: lastValue, right: newValues[i] });
        lastValue = newValues[i];
    }
    segments.push({ left: lastValue, right: max });
    return segments;
}
/**
 * Track displays color segments above Rail. Which, if any, segments that are
 * colorized is based on `trackDisplayMode`.
 */
const Track = (props) => {
    const { trackDisplayMode, sliderMin, sliderMax, values, orientation } = props;
    const [segments, setSegments] = React.useState(() => generateSegments(values, sliderMin, sliderMax));
    React.useEffect(() => {
        setSegments(generateSegments(values, sliderMin, sliderMax));
    }, [values, sliderMin, sliderMax]);
    return (React.createElement(React.Fragment, null, 'none' !== trackDisplayMode &&
        segments.map((segment, index) => {
            const lowPercent = segment.left >= sliderMin && sliderMax !== sliderMin
                ? (100.0 * (segment.left - sliderMin)) / (sliderMax - sliderMin)
                : 0;
            const highPercent = segment.right >= sliderMin && sliderMax !== sliderMin
                ? 100.0 -
                    (100.0 * (segment.right - sliderMin)) / (sliderMax - sliderMin)
                : 100;
            return (React.createElement(React.Fragment, { key: index }, shouldDisplaySegment(index, trackDisplayMode) ? (React.createElement("div", { className: 'iui-slider-track', style: {
                    ...(orientation === 'horizontal'
                        ? {
                            left: `${lowPercent}%`,
                            right: `${highPercent}%`,
                        }
                        : {
                            top: `${highPercent}%`,
                            bottom: `${lowPercent}%`,
                        }),
                } })) : null));
        })));
};
exports.Track = Track;
